import { Outlet, Navigate } from "react-router-dom";
import { getAuthToken } from "./authHelpers";

const ProtectedRoute = () => {
  const token = getAuthToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;